export default "__VITE_ASSET__8fe92ac8__"